import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const YOTPO_INTEGRATION_NAME = 'yotpo';
export const ZYotpoCredentials = z.object({
    guid: z.string().min(1),
    apiKey: z.string().min(1),
});
export const ZYotpoSettings = z.object({
    showPointsEstimation: z.boolean().optional(),
    allowPointsRedemption: z.boolean().optional(),
});
export const ZYotpoExternalData = z.object({
    campaigns: z
        .array(z.object({
        id: z.number(),
        name: z.string(),
        earningRatio: z.number().optional(),
        unrenderedDetails: z.string().optional(),
    }))
        .optional(),
    redemptionOptions: z
        .array(z.object({
        id: z.union([z.string(), z.number()]),
        name: z.string(),
        pointsCost: z.number(),
        discountAmount: z.number().optional(),
        discountPercentage: z.number().optional(),
        discountType: z.string().optional(),
        discountRateCents: z.number().optional(),
        currency: z.string().optional(),
        variantId: z.string().optional(),
        cartMinimum: z.number().optional(),
        description: z.string().optional(),
    }))
        .optional(),
    lastSyncedAt: z.iso.datetime().optional(),
});
export const ZYotpoIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(YOTPO_INTEGRATION_NAME),
    category: z.literal('loyalty'),
    credentials: ZYotpoCredentials,
    settings: ZYotpoSettings,
    externalData: ZYotpoExternalData.optional(),
}).shape);
//# sourceMappingURL=yotpo.js.map